export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return;

  const { public: { gtag } } = useRuntimeConfig();
  const enabled = gtag.enabled && Boolean(gtag.id);

  if (enabled) {
    console.info('[gtag] enabled', {
      measurementId: gtag.id,
      debugMode: gtag.config?.debug_mode,
    });
  } else {
    console.info('[gtag] disabled', {
      reason: gtag.enabled ? 'No measurement ID configured' : 'Disabled by configuration',
    });
  }
});
